import React, { useEffect, useState } from "react";
import { getData, putData } from "../../../services/library";
import {
  Typography,
  Box,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  InputAdornment,
  Chip,
  Divider,
  Alert,
  CircularProgress,
} from "@mui/material";
import Notify from "../../Notify";
import moment from "moment";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  verificarLinkGranel,
  mensajeError,
} from "../linkPago/services/linkGranelMp.service";

// mismo encabezado que el modal principal, para los diálogos secundarios
const estiloTituloDialogo = { backgroundColor: "#1F618D", color: "#fff" };

const formatearMonto = (monto) =>
  Number(monto).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ESTADO_LINK = {
  generado: { texto: "Generado (sin pagar)", color: "warning" },
  pagado: { texto: "Pagado", color: "success" },
  anulado: { texto: "Anulado", color: "default" },
  expirado: { texto: "Expirado", color: "default" },
};

// Link a mostrar: el pagado, si no el generado, si no el último (anulado / expirado)
const linkPrincipal = (links) =>
  links.find((l) => l.estado === "pagado") ||
  links.find((l) => l.estado === "generado") ||
  links[0] ||
  null;

const textoPagoLink = (link) =>
  `Pago confirmado con link N° ${link.id}: $${formatearMonto(link.monto_pagado ?? link.monto)}` +
  (link.payment_id ? ` (pago MP ${link.payment_id})` : "");

// Datos del link de pago (tarjeta del modal y aviso al aprobar)
function DatosLink({ link }) {
  const estado = ESTADO_LINK[link.estado] || { texto: link.estado, color: "default" };
  return (
    <Grid container spacing={0.5}>
      <DatoCliente label="Link N°" valor={link.id} />
      <Grid item xs={4}>
        <Typography variant="body2" color="textSecondary">
          Estado
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Chip label={estado.texto} color={estado.color} size="small" />
      </Grid>
      <DatoCliente label="Monto" valor={`$ ${formatearMonto(link.monto)}`} />
      {link.referencia ? <DatoCliente label="Referencia" valor={link.referencia} /> : null}
      {link.estado === "pagado" ? (
        <>
          <DatoCliente
            label="Monto pagado"
            valor={`$ ${formatearMonto(link.monto_pagado ?? link.monto)}`}
          />
          <DatoCliente
            label="Fecha de pago"
            valor={link.fecha_pago ? moment(link.fecha_pago).format("DD-MM-YYYY HH:mm") : "-"}
          />
          <DatoCliente label="N° de pago MP" valor={link.payment_id || "-"} />
        </>
      ) : null}
    </Grid>
  );
}

// fila etiqueta / valor de la información del cliente
function DatoCliente({ label, valor }) {
  return (
    <>
      <Grid item xs={4}>
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body1" fontWeight="bold">
          {valor}
        </Typography>
      </Grid>
    </>
  );
}

export default function Modalobservaciones(props) {
  const [datos, setdatos] = useState(props.datos);
  const [observaciones, setObservaciones] = useState(null);
  const [almacenarobservaciones, setalmacenarobservaciones] = useState({
    id_pedidos: datos.id,
    observaciones: "",
    usuario: localStorage.getItem("user"),
    monto: "", //cambio asignado por mica hecho por guille a, abrazo
  });
  const [detalles, setDetalles] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [existeMonto, setexisteMonto] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [disBtn, setDisBtn] = useState(false);
  const [accionSinGrabar, setAccionSinGrabar] = useState(null); // "aprobar" | "pendiente" | null
  const [procesandoSinGrabar, setProcesandoSinGrabar] = useState(false);
  // Links de pago del pedido (pedidos de pago anticipado)
  const [links, setLinks] = useState(null);
  const [verificandoLink, setVerificandoLink] = useState(false);
  const [errorLink, setErrorLink] = useState(null);

  const obtenerObservacionesPedidos = () => {
    getData("/gestion/" + datos.id, setObservaciones);
  };

  const obtenerdetalles = async () => {
    getData(
      "/pedidos/detalle/" + datos.id_cliente + "/" + datos.id,
      setDetalles
    );
  };

  //tarea  observaciones - Al guardar o ante un error, no se muestra ningún mensaje que notifique al usuario.
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // 'success' | 'error'

  useEffect(() => {
    obtenerObservacionesPedidos();
  }, []);

  const obtenerLinks = () =>
    fetch(UrlApi + "/granel_link_pago/xpedido/" + datos.id)
      .then((res) => res.json())
      .then((data) => setLinks(Array.isArray(data) ? data : []))
      .catch(() => setLinks([]));

  useEffect(() => {
    if (datos.id_condicionpago === 2 || datos.mantiene_precio === 1) obtenerLinks();
  }, []);

  const link = links ? linkPrincipal(links) : null;
  const linkPagado = link?.estado === "pagado" ? link : null;
  const linkPendiente = link?.estado === "generado" ? link : null;

  // Consulta el link en Mercado Pago (cuenta según la empresa del link) y actualiza su estado
  const verificarLink = async () => {
    if (!linkPendiente) return;
    setVerificandoLink(true);
    setErrorLink(null);
    try {
      await verificarLinkGranel(linkPendiente.id_empresa, linkPendiente.id);
      await obtenerLinks();
    } catch (error) {
      setErrorLink(mensajeError(error, "No se pudo verificar el link de pago"));
    } finally {
      setVerificandoLink(false);
    }
  };

  // Observación automática de la aprobación de un pedido de pago anticipado
  const registrarObservacionAprobacion = async (texto) => {
    try {
      await fetch(UrlApi + "/gestion", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          observaciones: texto,
          usuario: localStorage.getItem("user"),
          id_pedidos: datos.id,
          monto: null,
        }),
      });
    } catch (error) {
      // La aprobación sigue aunque no se pueda guardar la observación
      console.error("No se pudo guardar la observación de la aprobación:", error);
    }
  };

  const aprobarAbonado = async (e) => {
    await registrarObservacionAprobacion(
      linkPagado ? textoPagoLink(linkPagado) : "Aprobado como abonado (sin link de pago pagado)"
    );
    handleMatienePrecioAprobar(e);
  };

  const aprobarNoAbonado = async (e) => {
    await registrarObservacionAprobacion(
      "Aprobado como no abonado" +
        (link && (link.estado === "pagado" || link.estado === "generado")
          ? ` (link N° ${link.id} ${link.estado})`
          : "")
    );
    handleNoMantieneyAprobar(e);
  };

  useEffect(() => {
    obtenerdetalles();
  }, [datos]);

  useEffect(() => {
    setDisBtn(!esFormularioValido());
  }, [almacenarobservaciones]);

  useEffect(() => {
    if (observaciones && observaciones.length > 0) {
      const hayMonto = observaciones.some((o) => o.monto);
      setexisteMonto(hayMonto);
    } else {
      setexisteMonto(false);
    }
  }, [observaciones]);

  const handleAbrirModal = () => setOpenModal(true);
  const handleCerrarModal = () => setOpenModal(false);

  //guardar la observacion del pedido
  const handleGuardarObservacion = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    if (!esFormularioValido()) {
      setSnackbarSeverity("error");
      setSnackbarMessage(
        "Debe completar al menos Observaciones o un Monto válido."
      );
      setOpenSnackbar(true);
      setDisBtn(false); // Reactivar el botón
      return false;
    }

    let guardado = false;
    // monto puede ser "" o null (almacenar guarda null si el campo queda vacío)
    const montoFormateado =
      almacenarobservaciones.monto
        ? Number(
          almacenarobservaciones.monto.toString().replace(",", ".")
        ).toFixed(2)
        : null;

    try {
      const res = await fetch(UrlApi + "/gestion", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          observaciones: almacenarobservaciones.observaciones,
          usuario: localStorage.getItem("user"),
          id_pedidos: datos.id,
          monto: montoFormateado,
        }),
      });

      const data = await res.json();

      if (data.message === "OK") {
        guardado = true;
        setSnackbarSeverity("success");
        setSnackbarMessage("Observación guardada con éxito.");
        setOpenSnackbar(true);
        //limpio los campos despues
        setalmacenarobservaciones({
          observaciones: "",
          monto: ""
        });
      } else {
        throw new Error("Error inesperado en el servidor");
      }
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Error al guardar la observación.");
      setOpenSnackbar(true);
    } finally {
      setDisBtn(false);
    }

    obtenerObservacionesPedidos();
    logEventos(
      "Guardar observaciones para pedidos",
      "Gestion cta cte",
      "Gestion cta cte",
      localStorage.getItem("user")
    );
    return guardado;
  };

  const esFormularioValido = () => {
    const observacion = almacenarobservaciones.observaciones?.trim();
    const monto = almacenarobservaciones.monto;

    const montoValido = isValidMonto(monto);

    return (observacion && observacion !== "") || montoValido;
  };

  const isValidMonto = (monto) => {
    if (!monto) return false;
    const valor = monto.toString().replace(",", ".");
    const regex = /^[0-9]+([.,][0-9]{1,2})?$/; // Hasta 2 decimales
    return regex.test(monto) && !isNaN(Number(valor));
  };

  // const handleCambiarEstado = (e) => {
  //   if (!existeMonto) {
  //     alert("Es necesario ingresar el monto que debe abonar el cliente en el campo correspondiente para poder aprobar el pedido.")
  //   } else {
  //     if (almacenarobservaciones.monto) {
  //       handleGuardarObservacion(e)
  //     }
  //     const date = moment().format("YYYY-MM-DD HH:mm:ss");
  //     putData(
  //       e,
  //       "/pedidos/" + datos.id,
  //       {
  //         id_estado: 21,
  //         kgacargar_original: datos.kgacargar,
  //         usuario_autoriza: localStorage.getItem("user"),
  //         fecha_hora_autoriza: date,
  //       },
  //       setNotificacion,
  //       logEventos(
  //         "Cambiar de estado de pedidos",
  //         "Gestion cta cte ",
  //         "Gestion cta cte",
  //         localStorage.getItem("user")
  //       )
  //     );
  //   }

  // };

  const handleMatienePrecioAprobar = (e) => {
    const date = moment().format("YYYY-MM-DD HH:mm:ss");
    putData(
      e,
      "/pedidos/" + datos.id,
      {
        mantiene_precio: 1,
        usuario_autoriza: localStorage.getItem("user"),
        id_estado: 21,
        fecha_hora_autoriza: date,
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos",
        "Gestion cta cte ",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  const handleNoMantieneyAprobar = (e) => {
    const date = moment().format("YYYY-MM-DD HH:mm:ss");

    putData(
      e,
      "/pedidos/" + datos.id,
      {
        mantiene_precio: 0,
        usuario_autoriza: localStorage.getItem("user"),
        id_estado: 21,
        fecha_hora_autoriza: date,
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos",
        "Gestion cta cte ",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  const handlePendiente = (e) => {
    putData(
      e,
      "/pedidos/" + datos.id,
      {
        id_estado: 19,
        kgacargar_original: datos.kgacargar,
        // usuario_autoriza:
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos de 21 a 19",
        "Gestion cta cte ",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  const handleClose = () => {
    props.open(false);
  };

  // //para el onchange
  const almacenar = (e) => {
    setalmacenarobservaciones({
      ...almacenarobservaciones,
      [e.target.name]: e.target.value ? e.target.value : null,
    });
  };

  // montoGrabado: true si se acaba de grabar un monto desde el aviso de comentario sin grabar
  const handleCambiarEstado = async (e, montoGrabado = false) => {
    e.preventDefault();

    if (datos.id_condicionpago === 21 && !existeMonto && !montoGrabado) {
      alert(
        "Es necesario ingresar el monto que debe abonar el cliente en el campo correspondiente para poder aprobar el pedido."
      );
      return; // detener la ejecución
    }

    // 👇 PutData se ejecuta siempre después de pasar la validación
    const date = moment().format("YYYY-MM-DD HH:mm:ss");

    putData(
      e,
      `/pedidos/${datos.id}`,
      {
        id_estado: 21,
        kgacargar_original: datos.kgacargar,
        usuario_autoriza: localStorage.getItem("user"),
        fecha_hora_autoriza: date,
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos",
        "Gestion cta cte",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  //------------- COMENTARIO SIN GRABAR AL APROBAR / PENDIENTE ---------------------//
  const esPagoAnticipado =
    datos.id_condicionpago === 2 || datos.mantiene_precio === 1;

  const hayComentarioSinGrabar = () =>
    !!(almacenarobservaciones.observaciones?.trim() || almacenarobservaciones.monto);

  const continuarAprobacion = (e, montoGrabado = false) => {
    if (esPagoAnticipado) {
      handleAbrirModal();
    } else {
      handleCambiarEstado(e, montoGrabado);
    }
  };

  const continuarAccion = (e, accion, montoGrabado = false) => {
    if (accion === "aprobar") {
      continuarAprobacion(e, montoGrabado);
    } else {
      handlePendiente(e);
    }
  };

  // accion: "aprobar" | "pendiente"
  const handleClickAccion = (e, accion) => {
    if (hayComentarioSinGrabar()) {
      setAccionSinGrabar(accion);
    } else {
      continuarAccion(e, accion);
    }
  };

  const handleGrabarYContinuar = async (e) => {
    const accion = accionSinGrabar;
    const montoIngresado = almacenarobservaciones.monto;

    if (montoIngresado && !isValidMonto(montoIngresado)) {
      alert("El monto ingresado no es válido. Use punto o coma como separador decimal.");
      return;
    }

    setProcesandoSinGrabar(true);
    const guardado = await handleGuardarObservacion(e);
    setProcesandoSinGrabar(false);
    setAccionSinGrabar(null);
    // si no se pudo grabar, no se continúa con la acción
    if (!guardado) return;

    continuarAccion(e, accion, !!montoIngresado);
  };

  const handleContinuarSinGrabar = (e) => {
    const accion = accionSinGrabar;
    setAccionSinGrabar(null);
    setalmacenarobservaciones({
      ...almacenarobservaciones,
      observaciones: "",
      monto: "",
    });
    continuarAccion(e, accion);
  };

  // si el monto es obligatorio y no hay uno grabado, no se permite aprobar sin grabar
  const montoObligatorioSinGrabar =
    accionSinGrabar === "aprobar" &&
    !esPagoAnticipado &&
    datos.id_condicionpago === 21 &&
    !existeMonto;

  return (
    <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth="lg">
      <Box backgroundColor={"#1F618D"}>
        <DialogTitle>
          <Typography variant="h5" align="center" color="#ffffff">
            Gestión Cuenta Corriente Pedido N° {datos.id}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box mb={3}>
              <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                <Typography variant="h6" color="primary">
                  Información del Cliente
                </Typography>
                {esPagoAnticipado && (
                  <Chip label="Pago anticipado" color="success" size="small" />
                )}
              </Box>
              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                {datos.cliente}
              </Typography>
              <Grid container spacing={1}>
                <DatoCliente label="Producto" valor={datos.nombre_producto} />
                <DatoCliente label="Cantidad" valor={`${datos.kgacargar} kg`} />
                <DatoCliente
                  label="Dirección de entrega"
                  valor={
                    datos.lugar
                      ? `${datos.direccion} (${datos.lugar})`
                      : datos.direccion
                  }
                />
                {datos.observaciones ? (
                  <DatoCliente
                    label="Observaciones"
                    valor={datos.observaciones}
                  />
                ) : null}
              </Grid>
            </Box>

            {esPagoAnticipado ? (
              <Box mb={3}>
                <Typography variant="h6" color="primary" mb={1}>
                  Link de pago
                </Typography>
                {links === null ? (
                  <CircularProgress size={20} />
                ) : !link ? (
                  <Typography variant="body2" color="textSecondary">
                    El pedido no tiene link de pago. Se genera desde Links de pago.
                  </Typography>
                ) : (
                  <Box p={1.5} border="1px solid #ccc" borderRadius={2}>
                    <DatosLink link={link} />
                    {linkPendiente ? (
                      <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={verificarLink}
                          disabled={verificandoLink}
                          startIcon={verificandoLink ? <CircularProgress size={14} /> : null}
                        >
                          Verificar
                        </Button>
                      </Box>
                    ) : null}
                    {errorLink ? (
                      <Alert severity="error" sx={{ mt: 1 }}>
                        {errorLink}
                      </Alert>
                    ) : null}
                  </Box>
                )}
              </Box>
            ) : null}

            <Typography variant="h6" color="primary" mb={1}>
              Otros pedidos abiertos del cliente
            </Typography>
            <Grid container spacing={2}>
              {detalles && detalles.length > 0 ? (
                detalles.map((row) => (
                  <Grid item xs={12} sm={6} key={row.id}>
                    <Box p={1.5} border="1px solid #ccc" borderRadius={2}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={1}
                        mb={0.5}
                      >
                        <Typography variant="body1">
                          Pedido N° <strong>{row.id}</strong>
                        </Typography>
                        <Chip label={row.valor} size="small" variant="outlined" />
                      </Box>
                      <Typography variant="body2" color="textSecondary">
                        {row.nombre_direccion}
                      </Typography>
                      <Typography variant="body2">
                        Kg a cargar: <strong>{row.kgacargar}</strong>
                      </Typography>
                    </Box>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary">
                    No tiene otros pedidos pendientes.
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" color="primary" mb={1}>
              Observaciones
            </Typography>
            <Box sx={{ maxHeight: 320, overflowY: "auto", pr: 1 }}>
              {observaciones && observaciones.length > 0 ? (
                [...observaciones]
                  .sort((a, b) => b.id - a.id) //- Las observaciones deben ordenarse desde la más reciente a la más antigua. tarea
                  .map((row) => (
                    <Box
                      key={row.id}
                      mb={1}
                      p={1}
                      style={{ border: "1px solid #ccc", borderRadius: 5 }}
                    >
                      <Typography variant="caption" color="textSecondary">
                        {moment(row.created_at).format("DD-MM-YYYY HH:mm")} ·{" "}
                        {row.usuario}
                      </Typography>
                      {row.observaciones ? (
                        <Typography variant="body1">
                          {row.observaciones}
                        </Typography>
                      ) : null}
                      {row.monto ? (
                        <Typography variant="body2">
                          Monto a pagar:{" "}
                          <strong>$ {formatearMonto(row.monto)}</strong>
                        </Typography>
                      ) : null}
                    </Box>
                  ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No hay observaciones.
                </Typography>
              )}
            </Box>

            <Typography
              variant="subtitle1"
              color="primary"
              fontWeight="bold"
              mt={3}
              mb={1}
            >
              Nueva observación
            </Typography>
            <form autoComplete="off">
              <TextField
                fullWidth
                label="Agregar Observaciones"
                placeholder="Escribe aquí..."
                name="observaciones"
                multiline
                minRows={3}
                variant="outlined"
                value={almacenarobservaciones.observaciones || ""}
                onChange={almacenar}
              />
            </form>

            <Box mt={2}>
              <form autoComplete="off">
                <TextField
                  fullWidth
                  required={datos.id_condicionpago === 21}
                  label="Monto que debe abonar el cliente"
                  placeholder="Ej: 1000.50"
                  name="monto"
                  variant="outlined"
                  value={almacenarobservaciones.monto || ""}
                  onChange={(e) => {
                    const valor = e.target.value;

                    // Permitir solo números, punto y coma
                    const regex = /^[0-9.,]*$/;
                    if (regex.test(valor)) {
                      almacenar({ target: { name: "monto", value: valor } });
                    }
                  }}
                  //icono $
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                    inputMode: "decimal",
                  }}
                  helperText={
                    almacenarobservaciones.monto &&
                      !isValidMonto(almacenarobservaciones.monto)
                      ? "Monto no válido. Use punto o coma como separador decimal."
                      : ""
                  }
                  error={
                    almacenarobservaciones.monto &&
                    !isValidMonto(almacenarobservaciones.monto)
                  }
                />
              </form>
            </Box>

            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="secondary"
                onClick={handleGuardarObservacion}
                disabled={disBtn}
              >
                Grabar comentario
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <Divider />
      <DialogActions sx={{ px: 3, py: 2, justifyContent: "space-between" }}>
        <Button variant="contained" color="error" onClick={handleClose}>
          Volver
        </Button>
        {datos.id_estado === 19 ? (
          <Button
            variant="contained"
            style={{ backgroundColor: "#288d1f", color: "#fff" }}
            onClick={(e) => handleClickAccion(e, "aprobar")}
          >
            Aprobar
          </Button>
        ) : datos.id_estado === 21 ? (
          <Button
            variant="contained"
            color="warning"
            onClick={(e) => handleClickAccion(e, "pendiente")}
          >
            Pendiente
          </Button>
        ) : null}
      </DialogActions>

      <Dialog
        open={openModal}
        onClose={handleCerrarModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={estiloTituloDialogo}>
          {linkPagado ? "Confirmar pago" : "¿El pedido fue abonado?"}
        </DialogTitle>
        <DialogContent>
          {linkPagado ? (
            <>
              <Alert severity="warning" sx={{ mt: 2, mb: 1.5 }}>
                El pedido tiene un link de pago pagado. Revisá los datos y confirmá el pago.
              </Alert>
              <DatosLink link={linkPagado} />
            </>
          ) : linkPendiente ? (
            <Alert
              severity="warning"
              sx={{ mt: 2 }}
              action={
                <Button color="inherit" size="small" onClick={verificarLink} disabled={verificandoLink}>
                  Verificar
                </Button>
              }
            >
              Tiene el link N° {linkPendiente.id} por $ {formatearMonto(linkPendiente.monto)} sin pagar.
            </Alert>
          ) : null}
          {errorLink && openModal ? (
            <Alert severity="error" sx={{ mt: 1 }}>
              {errorLink}
            </Alert>
          ) : null}
          <Typography variant="body2" mt={2}>
            Si el pedido fue abonado, se mantendrá el precio al momento de la
            carga.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: "space-between" }}>
          {linkPagado ? <Button onClick={handleCerrarModal}>Cancelar</Button> : null}
          <Button
            variant="contained"
            color="success"
            onClick={aprobarAbonado} // Pedido abonado, mantener precio
          >
            {linkPagado ? "Confirmar pago" : "Pedido Abonado"}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={aprobarNoAbonado} // Pedido no abonado, no mantener precio
          >
            Pedido No Abonado
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={accionSinGrabar !== null}
        onClose={() => !procesandoSinGrabar && setAccionSinGrabar(null)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={estiloTituloDialogo}>
          Hay un comentario sin grabar
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" mt={2}>
            ¿Querés grabarlo antes de{" "}
            {accionSinGrabar === "pendiente"
              ? "pasar el pedido a pendiente"
              : "aprobar el pedido"}
            ?
          </Typography>
          {montoObligatorioSinGrabar && (
            <Typography variant="body2" color="textSecondary" mt={1}>
              El monto es obligatorio para aprobar este pedido.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            color="error"
            disabled={procesandoSinGrabar}
            onClick={() => setAccionSinGrabar(null)}
          >
            Cancelar
          </Button>
          {!montoObligatorioSinGrabar && (
            <Button
              disabled={procesandoSinGrabar}
              onClick={handleContinuarSinGrabar}
            >
              {accionSinGrabar === "pendiente"
                ? "Continuar sin grabar"
                : "Aprobar sin grabar"}
            </Button>
          )}
          <Button
            variant="contained"
            color="success"
            disabled={procesandoSinGrabar}
            onClick={handleGrabarYContinuar}
          >
            {accionSinGrabar === "pendiente"
              ? "Grabar y continuar"
              : "Grabar y aprobar"}
          </Button>
        </DialogActions>
      </Dialog>

      {notificacion && notificacion.open && (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleClose}
          severity={notificacion.severity}
        />
      )}
    </Dialog>
  );
}
//------------- FECHA ACTUAL ---------------------//
// OBTENER FECHA ACTUAL
//const date = moment().format("YYYY-MM-DD HH:mm:ss");
// console.log("datos", datos);
// console.log("FECHA DE HOY", date);

// useEffect(() => {
//     switch (datos.id_estado) {
//         case 19:
//             setdisbtn(false)
//             setDisbtnAprobar(false)
//             break;
//         case 21:
//             setdisbtn(false)
//             setDisbtnAprobar(true)
//             break;

//         default:
//             break;
//     }
// }, [datos.id_estado]);

// console.log("datos", datos);